/* eslint no-param-reassign: 0 */
import { CustomersService } from '../services/customers.service';

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    /**
     * Get customers
     * @param {Object} params
     * @returns {Object?}
     */
    getCustomers: async (_, params = {}) => {
      try {
        const customers = await CustomersService.getCustomers(params);
        return customers;
      } catch (e) {
        return false;
      }
    },
    /**
     * Get customer with ID
     * @param {String} id
     * @returns {Object?}
     */
    getCustomer: async (_, id) => {
      try {
        const customer = await CustomersService.getCustomer(id);
        return customer;
      } catch (e) {
        return false;
      }
    },
    getCustomerActivity: async (_, id) => {
      try {
        const customer = await CustomersService.getCustomerActivity(id);
        return customer;
      } catch (e) {
        return false;
      }
    },
    exportCustomers: async (_, ids) => {
      try {
        const data = await CustomersService.exportCustomers(ids);
        return data;
      } catch (e) {
        return false;
      }
    },
    deleteCustomers: async (_, ids) => {
      try {
        const data = await CustomersService.deleteCustomers(ids);
        return data;
      } catch (e) {
        return false;
      }
    },
    addNote: async (_, { id, note }) => {
      try {
        await CustomersService.addNote(id, note);
        return true;
      } catch (e) {
        return false;
      }
    },
    deleteNote: async (_, { id, note }) => {
      try {
        await CustomersService.deleteNote(id, note);
        return true;
      } catch (e) {
        return false;
      }
    },
  },
};
